import { createReducer } from 'src/utils/reducer'
import * as actionTypes from 'src/constants/actionTypes'

export const initialRunbookTemplatesState = {
    byId: {},
    values: [],
    loading: false,
    selectedTemplate: null,
    selectedTemplateActions: [],
    selectedTemplateId: null,
    loadingSelectedTemplate: false,
    loadingSelectedTemplateActions: false,
    savingSelectedTemplateActions: false,
    page: 1,
    requestedPage: null,
    requestedSort: '',
    requestedRequestKey: '',
    loadedPage: null,
    loadedSort: '',
    loadedRequestKey: '',
    totalElements: null,
    perPage: 1000,
    totalPages: null,
}

const runbookTemplates = createReducer(initialRunbookTemplatesState, {
    [actionTypes.GET_RUNBOOK_TEMPLATES]: (state, action) => ({
        ...state,
        loading: true,
        requestedPage: action.page || state.page,
        requestedSort: action.sort || '',
        requestedRequestKey: action.requestKey || '',
    }),
    [actionTypes.GET_RUNBOOK_TEMPLATES_SUCCESS]: (state, action) => {
        const payloadData = action.payload.data
        const templates = payloadData.results || []
        const pageData = payloadData._page
        const byId = templates.reduce(
            (accumulator, value) => ({
                ...accumulator,
                [value.id]: value,
            }),
            {}
        )
        const values = templates.map((value) => value.id)

        return {
            ...state,
            loading: false,
            requestedPage: pageData.page,
            requestedSort: action.sort || '',
            requestedRequestKey: action.requestKey || '',
            loadedPage: pageData.page,
            loadedSort: action.sort || '',
            loadedRequestKey: action.requestKey || '',
            totalElements: pageData.total_elements,
            totalPages: pageData.total_pages,
            perPage: pageData.per_page,
            byId,
            values,
        }
    },
    [actionTypes.CHANGE_RUNBOOK_TEMPLATES_PAGE]: (state, action) => ({
        ...state,
        page: action.page,
    }),
    [actionTypes.GET_RUNBOOK_TEMPLATES_ERROR]: (state) => ({
        ...state,
        loading: false,
    }),
    [actionTypes.GET_RUNBOOK_TEMPLATE]: (state, action) => ({
        ...state,
        selectedTemplateId: action.templateId,
        loadingSelectedTemplate: true,
    }),
    [actionTypes.GET_RUNBOOK_TEMPLATE_SUCCESS]: (state, action) => {
        const template = action.payload?.data || null

        if (!template || !template.id) {
            return {
                ...state,
                loadingSelectedTemplate: false,
                selectedTemplate: template,
            }
        }

        return {
            ...state,
            loadingSelectedTemplate: false,
            selectedTemplate: template,
            byId: {
                ...state.byId,
                [template.id]: template,
            },
            values: state.values.includes(template.id)
                ? state.values
                : [...state.values, template.id],
        }
    },
    [actionTypes.GET_RUNBOOK_TEMPLATE_ERROR]: (state) => ({
        ...state,
        loadingSelectedTemplate: false,
    }),
    [actionTypes.GET_RUNBOOK_TEMPLATE_ACTIONS]: (state, action) => ({
        ...state,
        selectedTemplateId: action.templateId,
        loadingSelectedTemplateActions: true,
        selectedTemplateActions:
            state.selectedTemplateId === action.templateId
                ? state.selectedTemplateActions
                : [],
    }),
    [actionTypes.GET_RUNBOOK_TEMPLATE_ACTIONS_SUCCESS]: (state, action) => {
        const payloadData = action.payload?.data
        const selectedTemplateActions = Array.isArray(payloadData)
            ? payloadData
            : payloadData?.results || []

        return {
            ...state,
            loadingSelectedTemplateActions: false,
            selectedTemplateActions,
        }
    },
    [actionTypes.GET_RUNBOOK_TEMPLATE_ACTIONS_ERROR]: (state) => ({
        ...state,
        loadingSelectedTemplateActions: false,
        selectedTemplateActions: [],
    }),
    [actionTypes.SAVE_RUNBOOK_TEMPLATE_ACTIONS]: (state) => ({
        ...state,
        savingSelectedTemplateActions: true,
    }),
    [actionTypes.SAVE_RUNBOOK_TEMPLATE_ACTIONS_SUCCESS]: (state) => ({
        ...state,
        savingSelectedTemplateActions: false,
    }),
    [actionTypes.SAVE_RUNBOOK_TEMPLATE_ACTIONS_ERROR]: (state) => ({
        ...state,
        savingSelectedTemplateActions: false,
    }),
    [actionTypes.DELETE_RUNBOOK_TEMPLATE]: (state) => ({
        ...state,
        loading: true,
    }),
    [actionTypes.DELETE_RUNBOOK_TEMPLATE_RECEIVED]: (state, action) => {
        const {
            [action.templateId]: _deletedTemplate,
            ...nextById
        } = state.byId
        const nextValues = state.values.filter((id) => id !== action.templateId)

        return {
            ...state,
            loading: false,
            byId: nextById,
            values: nextValues,
            totalElements: Math.max((state.totalElements || 0) - 1, 0),
        }
    },
    [actionTypes.DELETE_RUNBOOK_TEMPLATE_ERROR]: (state) => ({
        ...state,
        loading: false,
    }),
    [actionTypes.CREATE_RUNBOOK_TEMPLATE]: (state) => ({
        ...state,
        loading: true,
    }),
    [actionTypes.CREATE_RUNBOOK_TEMPLATE_SUCCESS]: (state, action) => {
        return {
            ...state,
            loading: false,
            // Invalidate request keys so the templates page re-fetches using
            // current filters/sort/page after a successful create.
            requestedRequestKey: '',
            loadedRequestKey: '',
        }
    },
    [actionTypes.CREATE_RUNBOOK_TEMPLATE_ERROR]: (state) => ({
        ...state,
        loading: false,
    }),
    [actionTypes.UPDATE_RUNBOOK_TEMPLATE]: (state) => ({
        ...state,
        loading: true,
    }),
    [actionTypes.UPDATE_RUNBOOK_TEMPLATE_SUCCESS]: (state) => ({
        ...state,
        loading: false,
        // Invalidate request keys so the templates page re-fetches using
        // current filters/sort/page after a successful update.
        requestedRequestKey: '',
        loadedRequestKey: '',
    }),
    [actionTypes.UPDATE_RUNBOOK_TEMPLATE_ERROR]: (state) => ({
        ...state,
        loading: false,
    }),
})

export default runbookTemplates
